import { Banknote, CreditCard } from 'lucide-react'
import { formatAmount } from './money'
import './receipt-table.css'

export interface ReceiptPaymentValue { total: number | null; cash: number | null; card: number | null }
const money = (value: number | null) => formatAmount({ rubles: value })

/** Единая оплата чека в рублях; отсутствие разбивки не превращается в наличные. */
export function ReceiptPayment({ total, cash, card }: ReceiptPaymentValue) {
  const mixed = cash !== null && card !== null && cash > 0 && card > 0
  const known = cash !== null && card !== null
  return <div className="krp-receipt-payment" data-mixed={mixed || undefined}>
    <strong>{mixed && <small>Итого </small>}{money(total)}</strong>
    <div className="krp-receipt-payment__parts">
      {cash !== null && cash > 0 && <span aria-label={`Наличными: ${money(cash)}`} title="Наличными"><Banknote size={17} aria-hidden="true" />{mixed ? money(cash) : 'Наличные'}</span>}
      {card !== null && card > 0 && <span aria-label={`Картой: ${money(card)}`} title="Картой"><CreditCard size={17} aria-hidden="true" />{mixed ? money(card) : 'Карта'}</span>}
      {!known && <small>Разбивка оплаты не указана</small>}
      {known && cash === 0 && card === 0 && <small>Способ оплаты не указан</small>}
    </div>
  </div>
}
